import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box, Text } from '@chakra-ui/react'
import faqData from './utils'

const FAQSection: React.FC = () => (
  <>
    <Text fontSize="2xl" fontWeight="bold" mb={4} color="brand.secondary" textAlign="center">Frequently Asked Questions</Text>
    <Accordion>
      {faqData.map((faq, index) => (
        <AccordionItem key={index}>
          <h2>
            <AccordionButton>
              <Box as="span" flex='1' textAlign='left'>
                {faq.question}
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            {faq.answer}
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  </>
)

export default FAQSection
